import { REDUX_MODEL_KEY } from '../../../../redux/constants/key'
import getAssociationKeysReduxUtil from '../../../../redux/utils/get-associations-keys'
import getChangedValueReduxUtil from '../../../../redux/utils/get-changed-value'
import getDataValueReduxUtil from '../../../../redux/utils/get-data-value'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import createAssociationListAddReduxUtil from '../../../../redux/actions/create/create-association-list'
import createSingleAssociationAddReduxUtil from '../../../../redux/actions/create/create-single-association'

export default function createAssociationsAddReduxUtil (stateWrapper, payload) {
  let {
    instance,
    existingInstance
  } = payload
  const associationKeys = getAssociationKeysReduxUtil(instance)
  const isLocal = isNewReduxUtil(instance)
  if (associationKeys.length) {
    associationKeys.forEach(associationKey => {
      const changedAssociation = getChangedValueReduxUtil(instance, associationKey)
      const association = getDataValueReduxUtil(instance, associationKey) || changedAssociation

      if (!association) {
        return
      }

      const dataKey = isLocal ? REDUX_MODEL_KEY.CHANGED : REDUX_MODEL_KEY.DATA
      const dataPath = `${dataKey}.${associationKey}`
      const properties = {
        status: instance.status
      }
      const associationParams = {
        stateWrapper,
        association,
        existingInstance,
        isLocal,
        instance,
        dataPath,
        properties,
        associationKey
      }
      instance =
        Array.isArray(association)
          ? createAssociationListAddReduxUtil(associationParams)
          : createSingleAssociationAddReduxUtil(associationParams)
    })
  }
  return instance
}
